<div class="loading-container">
    <div class="spinner">
        <div class="spinner__ring"></div>
        <div class="spinner__ring"></div>
        <div class="spinner__ring"></div>
    </div>
    @if (message) {
    <p class="loading-message">{{ message }}</p>
    }
</div>